import { render, staticRenderFns } from "./MobileMenuButton.vue?vue&type=template&id=f0d4b662&scoped=true"
import script from "./MobileMenuButton.vue?vue&type=script&lang=ts"
export * from "./MobileMenuButton.vue?vue&type=script&lang=ts"
import style0 from "./MobileMenuButton.vue?vue&type=style&index=0&id=f0d4b662&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0d4b662",
  null
  
)

export default component.exports